import InstructionEditForm from "./instruction-edit-form";

export default InstructionEditForm;